import { render, staticRenderFns } from "./Contactus.vue?vue&type=template&id=0cadac20&scoped=true"
import script from "./Contactus.vue?vue&type=script&lang=js"
export * from "./Contactus.vue?vue&type=script&lang=js"
import style0 from "./Contactus.vue?vue&type=style&index=0&id=0cadac20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cadac20",
  null
  
)

export default component.exports